import { useState } from 'react'
import {
  Edit,
  ListButton,
  SaveButton,
  SimpleForm,
  Toolbar,
  TopToolbar,
  useRecordContext,
  useTranslate,
} from 'react-admin'
import { ToggleI18nButton, UpsertSection } from '~/components'

const SectionName = (props) => {
  const record = useRecordContext(props)

  const translate = useTranslate()
  return (
    <span>
      {translate(`resources.sections.name`, { smart_count: 1 })}: {record ? `${record.slug}` : ''}
    </span>
  )
}

const SectionEditActions = ({ data, showI18n, setShowI18n }) => (
  <TopToolbar>
    <ToggleI18nButton showI18n={showI18n} setShowI18n={setShowI18n} />
    <ListButton label='ra.action.back' />
  </TopToolbar>
)

// react-admin 5's <SaveButton> reads submit state from form context, so the
// handleSubmitWithRedirect / invalid / redirect / submitOnEnter props this used
// to thread through no longer exist.
const SectionEditToolbar = () => (
  <Toolbar>
    <SaveButton />
  </Toolbar>
)

export const SectionEdit = (props, record) => {
  const [showI18n, setShowI18n] = useState(false)

  return (
    <Edit
      title={<SectionName />}
      actions={<SectionEditActions showI18n={showI18n} setShowI18n={setShowI18n} />}
      disable
      {...props}
      redirect='list'
    >
      <SimpleForm warnWhenUnsavedChanges toolbar={<SectionEditToolbar />}>
        <UpsertSection {...props} showI18n={showI18n} />
      </SimpleForm>
    </Edit>
  )
}

export default SectionEdit
